"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CheckinPassService = void 0;
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _Api = _interopRequireDefault(require("../Api"));
var CheckinPassService = exports.CheckinPassService = /*#__PURE__*/(0, _createClass2["default"])(function CheckinPassService() {
  (0, _classCallCheck2["default"])(this, CheckinPassService);
});
(0, _defineProperty2["default"])(CheckinPassService, "checkinPass", function (_ref) {
  var id = _ref.id;
  return _Api["default"]["default"]().get("/pass/".concat(id));
});